import { createAction } from "redux-actions";
import { PAGE_SIZE_10 } from "../../constants/index";
import { apiPost, apiGet, apiDelete, apiPut } from "../../api/index";
import { urlReliefSecured, urlNextReliefSecured, urlTurnReliefSecured, urlExportReliefSecured } from "../../api/urls";
import moment from "moment-timezone";

const generateFilterQuery = ({ filters, page, pageSize, sort }) => {
  let filter = "?";
  page ? (filter += "page=" + page) : (filter += "page=1");
  pageSize
    ? (filter += "&pageSize=" + pageSize)
    : (filter += "&pageSize=" + PAGE_SIZE_10);

  if (filters) {
    if (filters.userCreatedUuid !== undefined)
      filter += "&userCreatedUuid=" + filters.userCreatedUuid;
    if (filters.observations !== undefined)
      filter += "&observations=" + filters.observations;
    if (filters.turnUuid !== undefined)
      filter += "&turnUuid=" + filters.turnUuid;
    if (filters.nextTurnUuid !== undefined)
      filter += "&nextTurnUuid=" + filters.nextTurnUuid;
    if (filters.createdAt !== undefined)
      filter += "&createdAt=" + filters.createdAt;
    if (filters.dateInit) {
      const dateInit = moment(filters.dateInit);
      filter += "&dateInit=" + dateInit.valueOf();
    }
    if (filters.dateEnd) {
      const dateEnd = moment(filters.dateEnd);
      filter += "&dateEnd=" + dateEnd.valueOf();
    }
  }
  if (sort) filter += "&sort=" + sort;
  return filter;
};

/**
 * register process.
 */
export const register = createAction("REGISTER_RELIEF", (obj) =>
  apiPost(urlReliefSecured, obj, undefined, true)(),
);

export const filterListReliefs = createAction(
  "FILTER_RELIEF",
  (filter, param) =>
    apiGet(urlReliefSecured + generateFilterQuery(filter), param, true)(),
);

/**
 * Update Relief.
 */
export const updateRelief = createAction("UPDATE_RELIEF", (obj, param) =>
  apiPut(urlReliefSecured, obj, param, true)(),
);

/**
 * Get Relief.
 */
export const getRelief = createAction("GET_RELIEF", (param) =>
  apiGet(urlReliefSecured, param, true)(),
);

export const getNextRelief = createAction("GET_RELIEF", (param) =>
  apiGet(urlNextReliefSecured, param, true)(),
);

export const getTurnUuidRelief = createAction("GET_RELIEF", (param) =>
  apiGet(urlTurnReliefSecured, param, true)(),
);

export const filterRelief = createAction("FILTER_RELIEF", (filter, param) =>
  apiGet(urlReliefSecured + generateFilterQuery(filter), param, true)(),
);

/**
 * Filter list orders.
 */
export const listReliefToExport = createAction(
  "EXPORT_FILTER_TURNS",
  (filter, param) =>
    apiGet(urlExportReliefSecured + generateFilterQuery(filter), param, true)()
);
